import { RevealText } from "src/components/animation/reveal-text"
import Button from "src/components/button"

function EducationAndTraining(){
    return(<div className="pt-[139px]">
        <div id="headline" className="relative flex flex-col justify-center items-center mx-[24px] sm:mx-[80px] md:mx-[120px] xl:mx-[240px] h-[480px] md:h-[496px] xl:h-full my-[0px] xl:my-[128px] gap-[16px]">
            <div className="text-[32px] lg:text-[48px] font-bold leading-[36px] lg:leading-[50px]">
                <RevealText><span className="font-lora font-medium italic">Future-Proof</span> Your Workforce <br/>with Expert IT Training.</RevealText>
            </div>
            <RevealText className="w-full lg:w-1/2 text-grey">From top university auditoriums to enterprise boardrooms. We deliver cutting-edge training in Cybersecurity, AI, and Modern Infrastructure to keep your company ahead of the curve.</RevealText>
            <div className="flex flex-row gap-[16px]">
                <Button color="yellow">Contact Sales</Button>
            </div>
            <img className="absolute right-0 top-0 animate-float-enhanced-a" src="/icons/star-1.svg"></img>
            <img className="absolute left-0 bottom-0 animate-float-enhanced-b" src="/icons/star-2.svg"></img>
        </div>
        <hr/>
        <div className="my-[96px] flex flex-col justify-center items-center gap-[32px]">
            <div>
                <p className="text-[24px] lg:text-[32px] font-semibold ">Building <span className="font-lora font-medium italic">Tech Awareness</span> Since Day OneSecure</p>
                <p className="text-grey">Harmoni Mitra Tekno started with a single mission: to advance cyber security awareness.<br/>We didn't just build systems; we built communities.</p>
            </div>
            <div className="grid grid-cols-1 xl:grid-cols-3 justify-center items-start xl:mx-[224px] gap-[16px] xl:gap-0 xl:divide-x-[1px]">
                    <div className="flex flex-col justify-start items-center gap-[16px] px-[32px]">
                        <img className="w-[65px]" src={"/icons/network-yellow.svg"}></img>
                        <h1 className="text-center text-[16px] lg:text-[20px] font-semibold font-lora">University Roadshows</h1>
                        <p className="text-center">We have proudly hosted highly attended, free educational webinars at top institutions, including ITB (Institut Teknologi Bandung), POLBAN (Politeknik Negeri Bandung), and PNJ (Politeknik Negeri Jakarta).</p>
                    </div>
                    <div className="flex flex-col justify-start items-center gap-[16px] px-[32px]">
                        <img className="w-[65px]" src={"/icons/clap-yellow.svg"}></img>
                        <h1 className="text-center text-[16px] lg:text-[20px] font-semibold font-lora">Premium Masterclasses</h1>
                        <p className="text-center">Successfully organized and delivered exclusive paid webinars focused on deep-dive technical implementations.</p>
                    </div>
                    <div className="flex flex-col justify-start items-center gap-[16px] px-[32px]">
                        <img className="w-[65px]" src={"/icons/computer-yellow.svg"}></img>
                        <h1 className="text-center text-[16px] lg:text-[20px] font-semibold font-lora">Our Philosophy</h1>
                        <p className="text-center">We believe that the best way to master technology is to teach it. The same experts who build our enterprise solutions are the ones training your team.</p>
                    </div>
                </div>
        </div>
        <hr/>
        <div className="my-[96px] flex flex-col gap-[18px] justify-center items-center">
            <div>
                <p className="text-[32px] font-semibold "><span className="font-lora font-medium italic">Empower</span> Your Team with Industry-Leading Skills</p>
                <p className="text-grey">We customize our training syllabus based on your company's existing infrastructure and goals.</p>
            </div>
             <div className="grid grid-cols-1 text-left lg:w-2/3 py-[24px] px-[24px]">
                <hr></hr>
                <div className="w-full flex flex-col md:flex-row gap-[8px] py-[16px]">
                    <div className="md:w-1/12">
                        <img className="" src="/icons/leaves-yellow.svg"></img>
                    </div>
                    <p className="md:w-2/12 font-lora font-semibold">Advanced Cybersecurity</p>
                    <p className="md:w-6/12">Network defense, Threat hunting, and Vulnerability assessments.</p>
                    <p className="md:w-3/12">Security Analysts, IT Admins</p>
                </div>
                <hr></hr>
                <div className="w-full flex flex-col md:flex-row gap-[8px] py-[16px]">
                    <div className="md:w-1/12">
                        <img className="" src="/icons/leaves-yellow.svg"></img>
                    </div>
                    <p className="md:w-2/12 font-lora font-semibold">Enterprise Security Tools</p>
                    <p className="md:w-6/12">Hands-on implementation and management of SIEM and FORTINET ecosystems.</p>
                    <p className="md:w-3/12">Network Engineers, DevSecOps</p>
                </div>
                <hr></hr>
                <div className="w-full flex flex-col md:flex-row gap-[8px] py-[16px]">
                    <div className="md:w-1/12">
                        <img className="" src="/icons/leaves-yellow.svg"></img>
                    </div>
                    <p className="md:w-2/12 font-lora font-semibold">Artificial Intelligence (AI)</p>
                    <p className="md:w-6/12">Artificial Intelligence (AI)</p>
                    <p className="md:w-3/12">Product Managers, Developers</p>
                </div>
                <hr></hr>
                <div className="w-full flex flex-col md:flex-row gap-[8px] py-[16px]">
                    <div className="md:w-1/12">
                        <img className="" src="/icons/leaves-yellow.svg"></img>
                    </div>
                    <p className="md:w-2/12 font-lora font-semibold">Modern Architecture</p>
                    <p className="md:w-6/12">Microservices transition, secure coding practices, and deployment pipelines.</p>
                    <p className="md:w-3/12">Software Engineers, Tech Leads</p>
                </div>
                <hr></hr>
            </div>
        </div>
        <hr/>
        <div className="px-[16px] md:px-[0px] relative py-[128px] flex flex-col gap-[24px] justify-center items-center text-center">
            <h1 className="text-[32px] lg:text-[48px] font-bold leading-[50px]">Ready to <span className="font-lora font-medium italic">elevate</span><br/> your company's technical edge? </h1>
            <Button to={"/contact-us"} onClick={() => {}} color={"black"}>Contact Sales</Button>
            <img className="absolute right-4 md:right-16 top-10 w-8 md:w-auto animate-float-enhanced-a opacity-50 md:opacity-100" src="/icons/star-1.svg" alt="" />
            <img className="absolute left-4 md:left-16 bottom-10 md:bottom-auto md:top-20 w-6 md:w-auto animate-float-enhanced-b opacity-50 md:opacity-100" src="/icons/star-2.svg" alt="" />
        </div>
    </div>)
}

export default EducationAndTraining